import { Component, effect, inject, model, output } from "@angular/core";
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { HeaderPassaggioConsegneForm, PassaggioConsegneResponse } from "../models/passaggio-consegne.model";
import { PassaggioConsegneService } from "../services/passaggio-consegne.service";
import { ConfirmationService, Message, MessageService } from "primeng/api";

@Component({
  selector: "app-passaggio-aggiunta-dialog",
  template: `
    <p-dialog [(visible)]="isOpen" [modal]="true" [closable]="false" [closeOnEscape]="false" [resizable]="false" [style]="{ height: '350px', width: '550px' }">
      <p-header>Inserisci nuovo passaggio di consegne</p-header>
      <form [formGroup]="headerForm" (ngSubmit)="confirmSelection()">
        <div class="grid">
          <div class="col-12">
            <label class="small-label" for="funzionarioUscente">Funzionario Uscente</label>
            <input pInputText type="text" id="funzionarioUscente" formControlName="funzionarioUscente"[style]="{ width: '420px' }"/>
          </div>
          <div class="col-12">
            <label class="small-label" for="funzionarioSubentrante">Funzionario Subentrante</label>
            <input pInputText type="text" id="funzionarioSubentrante"formControlName="funzionarioSubentrante"[style]="{ width: '420px' }"/>
          </div>
          <div class="col-12">
            <label class="small-label" class="small-label" for="dataPassaggioConsegne">Data passaggio di consegne</label>
            <p-calendar formControlName="dataPassaggioConsegne" inputId="dataDocumento" appendTo="body" [inputStyle]="{ width: '420px' }" 
                        dateFormat="dd/mm/yy" selectionMode="single" [showTime]="true" hourFormat="24" [showIcon]="true">
            </p-calendar>
          </div>
        </div>
      </form>
      <p-footer>
        <button pButton type="button" label="Conferma Registrazione" title="Conferma Registrazione" (click)="confirmSelection()" [disabled]="headerForm.invalid" class="mr-2"></button>
        <button pButton type="button" label="Chiudi" title="Chiudi" (click)="close()"class="p-button-secondary"></button>
      </p-footer>
    </p-dialog>
  `,
})
export class PassaggioAggiuntaDialogComponent {
  private readonly passaggioDiConsegneService = inject(
    PassaggioConsegneService
  );
  private readonly messageService = inject(MessageService);
  private readonly confirmationService = inject(ConfirmationService);
  private readonly fb = inject(FormBuilder);

  public isOpen = model<boolean>(false);
  public isAdded = output<boolean>();

  public headerForm: FormGroup<HeaderPassaggioConsegneForm>;

  private ultimoPassaggio: PassaggioConsegneResponse | undefined = undefined;

  constructor() {
    this.headerForm = this.fb.group<HeaderPassaggioConsegneForm>({
      funzionarioUscente: new FormControl(null, [Validators.required]),
      funzionarioSubentrante: new FormControl(null, [Validators.required]),
      dataPassaggioConsegne: new FormControl(new Date(), [Validators.required]),
    }, { validators: this.validateForm.bind(this) });

    effect(() => {
      if (this.isOpen()) {
        this.passaggioDiConsegneService.getUltimo().subscribe(res => {
          this.ultimoPassaggio = res;
          this.headerForm.patchValue({ funzionarioUscente: this.ultimoPassaggio?.funzionarioSubentrante });
        });
      }
    })
  }

  public close(): void {
    this.isOpen.set(false);
  }

  public cancel(): void {
    this.headerForm.reset();
    this.close();
  }

  public confirmSelection(): void {
    this.confirmationService.confirm({
      message: "Sei sicuro di voler completare l'operazione?",
      header: "Aggiunta nuovo passaggio di consegne",
      icon: "pi pi-exclamation-triangle",
      accept: () => this.submit(),
      reject: () => this.cancel(),
    });
  }

  public submit(): void {
    if (this.headerForm.valid) {
      if (
        this.headerForm.value.funzionarioUscente &&
        this.headerForm.value.funzionarioSubentrante &&
        this.headerForm.value.dataPassaggioConsegne
      ) {
        const request = {
          funzionarioUscente: this.headerForm.value.funzionarioUscente,
          funzionarioSubentrante: this.headerForm.value.funzionarioSubentrante,
          dataPassaggioConsegne: new Date(this.headerForm.value.dataPassaggioConsegne),
        };
        this.passaggioDiConsegneService.add(request).subscribe({
          next: () => {
            const message: Message = {
              severity: "success",
              summary: "Inserimento passaggio di consegne",
              detail: "Nuovo passaggio di consegne inserito con successo",
            };
            this.messageService.add(message);
            this.isAdded.emit(true);
          },
          error: () => {
            const message = {
              severity: "error",
              summary: "Errore",
              detail: "Sono stati inseriti dati non validi",
            };
            this.messageService.add(message);
          },
        });
      }
      this.headerForm.reset();
      this.close();
    }
  }

  private validateForm(control: AbstractControl): ValidationErrors | null {
    const form = control as FormGroup;

    const funzionarioUscente = form.get('funzionarioUscente')?.value;
    const funzionarioSubentrante = form.get('funzionarioSubentrante')?.value;
    const dataPassaggio = (form.get('dataPassaggioConsegne')?.value) ? new Date(form.get('dataPassaggioConsegne')?.value) : null;
    const dataUltimoPassaggio = (this.ultimoPassaggio?.dataPassaggioConsegne) ? new Date(this.ultimoPassaggio?.dataPassaggioConsegne) : null;

    const isValidDate = (dataUltimoPassaggio && dataPassaggio) ? (dataPassaggio > dataUltimoPassaggio) : true;

    return funzionarioUscente
      && ( funzionarioUscente == this.ultimoPassaggio?.funzionarioSubentrante || !this.ultimoPassaggio?.funzionarioSubentrante)
      && funzionarioSubentrante
      && dataPassaggio
      && isValidDate ? null : { nuovoPassaggioConsegneNotValid: true };
  }

}
